export default __webpack_public_path__ + "static/media/en.39fa3b28.svg";